import Vue from 'vue';
import Vuex from 'vuex';
import user from './user';
import payment from './payment';
import settings from './settings';
import embedPage from './embed_page';
import theme from './theme';
import VuexPersistence from 'vuex-persist';
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});
Vue.use(Vuex);

const shipper = {
  getters: {
    shipper: () => ({
      Fedex: 'http://www.fedex.com/Tracking?tracknumbers=',
      UPS: 'http://wwwapps.ups.com/WebTracking/processInputRequest?TypeOfInquiryNumber=T&InquiryNumber1=',
      USPS: 'https://tools.usps.com/go/TrackConfirmAction.action?tLabels=',
    }),
  },
};

export default new Vuex.Store({
  modules: {
    user,
    payment,
    settings,
    shipper,
    embedPage,
    theme,
  },
  plugins: [vuexLocal.plugin],
});
